import { motion } from "framer-motion";
import { Mail } from "lucide-react";

const SECTION_MOTION = {
  initial: { opacity: 0, y: -40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.9, ease: "easeInOut" },
};

export const ContactSection = () => {
  return (
    <>
      <motion.section
        className="isic-contact-bg py-16 md:py-20"
        {...SECTION_MOTION}
        data-testid="contact-section"
      >
        <div className="mx-auto max-w-[900px] px-6 text-center">
          <h3 className="text-xl font-semibold leading-8 text-white md:text-2xl">
            Dacă ai orice întrebare legată de obținerea legitimației tale, scrie-ne și te ajutăm
          </h3>
          <a
            href="mailto:vreau@isic.ro"
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-white/95 px-7 py-4 text-lg font-semibold text-[#2f68b0] shadow-lg transition-transform duration-300 hover:-translate-y-1"
            data-testid="contact-email"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#2f68b0] text-white">
              <Mail size={18} />
            </span>
            vreau@isic.ro
          </a>
        </div>
      </motion.section>

      <footer className="bg-[#2b2b2b] py-4" data-testid="footer-copyright">
        <div className="mx-auto max-w-[1100px] px-6">
          <p className="text-sm text-[#9a9a9a]">©ISIC Romania</p>
        </div>
      </footer>
    </>
  );
};
